export default __webpack_public_path__ + "static/LMBLogoIcon-b9c43e967652f9dff7152c3c937bf4a8.svg";